import React, { FC, PropsWithChildren } from "react"
import cls from "classnames"

import * as styles from './styles.module.scss';
import {IdHeading} from "components/organisms/IdHeading";

type Props = {
  background?: {
    desktoplg?: string
    desktop?: string
    tablet?: string
    phone?: string
  }

  className?: string
  childrenClassNames?: {
    title?: string
    content?: string
    body?: string
    background?: string
    bgCssStyle?: string
  }

  title?: string
  body?: React.ReactNode
  mainBody?: React.ReactNode
  buttons?: {
    caption: string
    href: string
    target?: '_self' | '_blank'
    style?: React.CSSProperties
    className?: string
  }[]
}

export const ListBlock = ({ className, childrenClassNames, background = {}, title, body, mainBody, buttons = [] }: Props) => {
  const { desktoplg, desktop, tablet, phone } = background;
  return (
      <>
        <div className={cls(styles.container, className, childrenClassNames?.bgCssStyle)}>
          {(desktop || tablet || phone) && (
              <picture>
                {desktoplg && <source srcSet={desktoplg} media="(min-width: 2200px)"/>}
                <source srcSet={desktop} media="(min-width: 1024px)" />
                <source srcSet={tablet} media="(min-width: 768px)" />
                <source srcSet={phone} media="(min-width: 1px)" />
                <img className={cls(styles.background, childrenClassNames?.background)}
                     decoding="async" loading="lazy" />
              </picture>
          )}
          <div className="bs-flex-container narrow">
            <div className={cls(styles.content, childrenClassNames?.content)}>
              <div className={cls(styles.contentBody, childrenClassNames?.body)}>
                <IdHeading headingLevel={2} className={cls(styles.title, childrenClassNames?.title)}>{title}</IdHeading>
                {mainBody && <div>{mainBody}</div>}
              </div>
              <div className={cls(styles.contentBody, childrenClassNames?.body)}>
                <div>{body}</div>
                {buttons && buttons.length > 0 && (
                    <div className={styles.buttons}>
                      {buttons.map(({ caption, href, target = '_self', className, style }) => (
                          <a key={caption} href={href} target={target} className={cls(styles.button, 'button-filled', className)} style={style}>
                            {caption}
                          </a>
                      ))}
                    </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
  )
}

export const ListTitle = ({ children, className }: PropsWithChildren<{ className?: string }> ) => (
  <IdHeading headingLevel={5} className={cls(styles.bodyTitle, className)}>{children}</IdHeading>
)

export const ListTitleSmall = ({ children, className }: PropsWithChildren<{ className?: string }> ) => (
  <IdHeading headingLevel={5} className={cls(styles.bodyTitle, styles.small, className)}>{children}</IdHeading>
)

type ULProps = React.HTMLAttributes<HTMLUListElement> & {
  children: (string | React.ReactNode)[],
  className?: string,
  itemClassName?: string
}

export const UnorderedList = ({ children, className, itemClassName }: ULProps) => (
  <ul className={cls(styles.list, styles.unorderedList, className)}>
    {children.map((item, index) => <li key={index} className={cls(styles.item, itemClassName)}>{item}</li>)}
  </ul>
)

type OLProps = React.HTMLAttributes<HTMLOListElement> & {
  children: (string | React.ReactNode)[],
  className?: string,
  itemClassName?: string
  listStyleType?: string
}

export const OrderedList = ({ children, className, itemClassName, listStyleType }: OLProps) => (
  <ol className={cls(styles.list, styles.orderedList, className)} style={{ listStyleType }}>
    {children.map((item, index) => <li key={index} className={cls(styles.item, itemClassName)}>{item}</li>)}
  </ol>
)
